export default __webpack_public_path__ + "static/media/hht1_ep05_timeline_q03_a.041122f0.png";